import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { InternalCustomerMasterDataAll } from '../../BaseController/types/internalContract';
import { CustomerBox } from './customerBox';

export interface CustomerContentProps {
  customerMasterData: InternalCustomerMasterDataAll[];
}

export const CustomerContent = (props: CustomerContentProps) => {
  const { t } = useTranslation();
  const { customerMasterData } = props;

  return (
    <div style={{ width: '100%' }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        width="100%"
        spacing={2}
      >
        <CustomerBox
          header={t('SoldToParty')}
          customerMasterData={
            customerMasterData.find((e) => e.type === 'customer')?.data
          }
        />
        <CustomerBox
          header={t('ShipToParty')}
          customerMasterData={
            customerMasterData.find((e) => e.type === 'shipToParty')?.data
          }
        />
        <CustomerBox
          header={t('InvoiceAddress')}
          customerMasterData={
            customerMasterData.find((e) => e.type === 'billToParty')?.data
          }
        />
      </Stack>
    </div>
  );
};
